export const getUrlExtension = (url) => url.split(/[#?]/)[0].split('.').pop().trim();
